export const getUrlSearchParams = (): URLSearchParams =>
  new URLSearchParams(window.location.search);
